import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';

import {Observable} from 'rxjs';
import {map, tap} from 'rxjs/operators';

import {AssetService, GroupAsset} from '../asset';
import {InspectorService} from '../inspector/inspector.service';
import {deserialize} from '../serializable';

@Injectable({
    providedIn: 'root',
})
export class GroupService {
    constructor(
        private assetService: AssetService,
        private inspectorService: InspectorService,
        private http: HttpClient,
    ) {}

    create(assetIds: string[], streamId: string): Observable<GroupAsset> {
        const url = `/api/group/`;
        const options = {
            ids: assetIds,
            stream_id: streamId,
            withCredentials: true,
        };

        return this.http.post(url, options).pipe(map((asset) => deserialize(GroupAsset, asset)));
    }

    append(groupAssetId: string, assetIds: string[]): Observable<GroupAsset> {
        const url = `/api/group/${groupAssetId}/`;
        const options = {
            ids: assetIds,
            action: 'append',
            withCredentials: true,
        };

        return this.http.patch(url, options).pipe(
            map((asset) => deserialize(GroupAsset, asset)),
            tap(() => this.assetService.removeAssets(assetIds)),
        );
    }

    insert(groupAssetId: string, assetId: string, index: number): Observable<GroupAsset> {
        const url = `/api/group/${groupAssetId}/`;
        const options = {
            id: assetId,
            index: index,
            withCredentials: true,
        };

        return this.http.patch(url, options).pipe(
            map((asset) => deserialize(GroupAsset, asset)),
            tap(() => this.assetService.removeAssets([assetId])),
        );
    }

    remove(groupAssetId: string, assetId: string): Observable<GroupAsset> {
        const url = `/api/group/${groupAssetId}/`;
        const options = {
            ids: [assetId],
            action: 'remove',
            withCredentials: true,
        };

        return this.http.patch(url, options).pipe(
            map((asset) => deserialize(GroupAsset, asset)),
            tap(() => this.assetService.filter(true)),
        );
    }

    ungroup(groupAssetId: string) {
        const url = `/api/group/${groupAssetId}/`;
        const options = {
            withCredentials: true,
        };

        return this.http.delete(url, options).pipe(
            tap(() => {
                // FIXME: Not sure if this is appropriate here
                // Clear the inspector sidenav
                this.inspectorService.inspect(null);
                // Force a get of assets again
                this.assetService.filter(true);
            }),
        );
    }
}
